import Vue from "vue";

import Cookies from "js-cookie";


Vue.mixin({
  methods: {
   
    auth: function() {
      if (Cookies.get("user")) {
        let auth = JSON.parse(Cookies.get("user"));
        if (auth) {
          return auth;
        }
      }
      return false;
    },
    isAuth: function(user) {
      let userData = Cookies.get("user")
      let auth;
      if (userData != undefined) {
        auth = JSON.parse(userData)
      }
      
      if (auth  && user) {
        return auth.id === user.id;
      }
      return false;
      
    },
     
    rentProduct: function() {
      if (Cookies.get("productDetails")) {
        let rentProduct = JSON.parse(Cookies.get("productDetails"));
        if (rentProduct) {
          return rentProduct;
        }
      }
      return false;
    },
    salesProductsQuantity: function() {
      if (Cookies.get("productsQuantity")) {
        // let salesProductsQuantity = Cookies.get("productsQuantity");
        let salesProductsQuantity = JSON.parse(Cookies.get("productsQuantity"));
        if (salesProductsQuantity) {
         
          return [...salesProductsQuantity];
        }
      }
      return false;
    },
    // for sales total products price
    salesProductsTotalPrice: function() {
      if (Cookies.get("totalProductsPrice")) {
        let totalProductsPrice = Cookies.get("totalProductsPrice");
        if (totalProductsPrice) {
          return totalProductsPrice;
        }
      }
      return 0;
    },
  }
});
